import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { timelineQKeys } from "@hooks/queries/timeline/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useCreateTreatmentPlan = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (treatmentPlan: FormData) => {
      return api.post("treatments/create", treatmentPlan, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (_, variables) => {
      // import.meta.env.DEV && console.log(res.data);
      showSuccessNotification({
        title: "success",
        message: "create-treatment-plan-success",
      });
      queryClient.invalidateQueries({
        queryKey: timelineQKeys.patient(variables.get("patient_id") as string),
      });
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.treatmentPlanWithFilters(
          variables.get("patient_id") as string
        ),
      });
    },

    onError: (res, variables) => {
      console.error("[From Create Treatment Plan]", res);
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.treatmentPlanWithFilters(
          variables.get("patient_id") as string
        ),
      });

      handleErrors(res, "mutation");
    },
  });
};
